/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifacts_Download_All_FailedInputs */



/**
* | output |
* | --- |
* | "None of the selected artifacts could be exported." |
*
* @param {Artifacts_Download_All_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifacts_download_all_failed = /** @type {((inputs?: Artifacts_Download_All_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifacts_Download_All_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keines der ausgewählten Artefakte konnte exportiert werden.")
	return /** @type {LocalizedString} */ ("None of the selected artifacts could be exported.")
});